// import instance from "./request";

import { get, post } from './request';

//登录接口
export const PostLogin = (params) => post('/admin/login', params)
export const GetAdminInfo = (params) => post('/admin/info', params)

//获取APP列表
export const GetAppList = (params) => get('/admin/app', params);
//获取APP详情
export const GetAppInfo = (id) => get('/admin/app', { appID: id });
//获取应用可视化配置
export const GetAppVisualConfig = (id) => get('/admin/app/' + id + '/visualConfig')
//保存应用可视化配置
export const SaveAppVisualConfig = (id, config) => post('/admin/app/' + id + '/visualConfig', { config: config })

//提交iOS打包
export const AppPack = (params) => post('admin/pack/iosTestingPack', params)


//获取素材组
export const GetMaterialGroupList = (params) => get('/admin/materialGroup', params);
//获取素材组的素材列表
export const GetMaterialGroupDetail = (group_id) => get('/admin/material', { group_id: group_id });
//获取图片大栏目
export const GetAtlasCategoryList = (params) => get('/admin/atlas/categories', params)
//获取图片标签
export const GetAtlasTagList = (params) => get('/admin/atlas/tags', params)
//获取图片标签组
export const GetAtlasTagGroup = (params) => get('/admin/atlas/tagGroup', params)

//上传图片
export const UploadIcon = (formdata) => post('/admin/image', formdata)